module.exports = __webpack_public_path__ + "img/ARN.b45a9171.svg";